// extracted by mini-css-extract-plugin
export default {"container":"menuNarrowDropDown-module--container--HaSws","content":"menuNarrowDropDown-module--content--wtA17","nested":"menuNarrowDropDown-module--nested--kwbSj"};